import { AlgoliaActions, AlgoliaEvents } from './actions';
import { AlgoliaState } from './types';

export const initialState: AlgoliaState = {};

export function algoliaReducer(state = initialState, action: AlgoliaActions): AlgoliaState {
    switch (action.type) {
        case AlgoliaEvents.ANALYTICS_INITIALISE:
        case AlgoliaEvents.ANALYTICS_CONSENT_CHANGED: {
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    anoymousUserToken: action.payload.anoymousUserToken,
                    initialised: true,
                },
            };
        }

        case AlgoliaEvents.ANALYTICS_SET_ANONYMOUS_USER_TOKEN: {
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    anoymousUserToken: action.payload.anoymousUserToken,
                },
            };
        }

        case AlgoliaEvents.ANALYTICS_SET_AUTHENTICATED_USER: {
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    authenticatedUserToken: action.payload.authenticatedUserToken,
                },
            };
        }

        case AlgoliaEvents.ANALYTICS_UNSET_AUTHENTICATED_USER: {
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    authenticatedUserToken: undefined,
                },
            };
        }

        default:
            return state;
    }
}
